module.exports = __webpack_public_path__ + "img/LogoPL.e69a14ea.svg";